import "./wrapper.root.scss";

import { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { Header } from "src/ui/fragments";
import { AccessibilityFooter } from "src/ui/fragments/accessibility_footer/accessibility_footer";

export const WrapperRoot = ({ children }: { children: ReactNode }) => {
  return (
    <Card>
      <div className="wrapper--header">
        <Header />
      </div>
      <div className="wrapper--body">
        <div className="container">{children}</div>
      </div>
      <div className="wrapper--footer">
        <AccessibilityFooter />
      </div>
    </Card>
  );
};
